import { render, staticRenderFns } from "./ModelFileUploader.vue?vue&type=template&id=5f641aa9&scoped=true&"
import script from "./ModelFileUploader.vue?vue&type=script&lang=ts&"
export * from "./ModelFileUploader.vue?vue&type=script&lang=ts&"
import style0 from "./ModelFileUploader.vue?vue&type=style&index=0&id=5f641aa9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f641aa9",
  null
  
)

export default component.exports